import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useApp } from '@/context/AppContext';

export const ThemeToggle = ({ className = '', testId = 'theme-toggle' }) => {
  const { theme, toggleTheme, tx } = useApp();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid={testId}
      title={tx({ es: isDark ? 'Modo claro' : 'Modo oscuro', en: isDark ? 'Light mode' : 'Dark mode' })}
      aria-label={tx({ es: isDark ? 'Modo claro' : 'Modo oscuro', en: isDark ? 'Light mode' : 'Dark mode' })}
      className={`inline-flex items-center justify-center w-9 h-9 rounded-lg transition-colors ${className}`}
    >
      {isDark ? <Sun className="w-4 h-4" strokeWidth={2} /> : <Moon className="w-4 h-4" strokeWidth={2} />}
    </button>
  );
};
